import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.corporate-settings.company-profile', {
        url: '/companyProfile',
        component: 'companyProfile',
        resolve: {settings, accessPolicies},
    });
}

/** @ngInject */
function settings(companyId,CorporateSettingsService) {
    return CorporateSettingsService.get(companyId);
}

/** @ngInject */
function accessPolicies(AuthenticationAccessPolicyResource, companyId) {
    const type='basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId,type);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/company-profile.state.js